<template>
    <div class="rzy-page">

        <el-row>
            <el-button type="success" plain>ID：{{this.$route.query.juanBuId}}</el-button>
            <el-button type="warning" plain>编号：{{this.$route.query.juanbuNumber}}</el-button>
        </el-row>

        <div style="margin-top: 10px;">
        </div>

        <el-table :data="responseData" :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}"
            border stripe id="localListTableId" @selection-change="handleSelectionChange">

            <el-table-column label="行" type="index" :index="indexMethod" align="center">
            </el-table-column>

            <el-table-column sortable prop="createTime_change" label="打包时间" align="center">
            </el-table-column>
            <el-table-column sortable prop="productLableNumber" label="胚布编码" align="center">
            </el-table-column>
            <el-table-column sortable prop="productName" label="胚布名称" align="center">
            </el-table-column>
            <el-table-column sortable prop="productLength" label="米数(米)" align="center">
            </el-table-column>
            <el-table-column sortable prop="realWeight_change" label="过磅重量(千克)" align="center">
            </el-table-column>
        </el-table>

        <el-pagination style="text-align: center" background layout="prev, pager, next"
            @current-change="handleCurrentChange" :page-size="pageInfo.size" :current-page="pageInfo.page"
            :page-count="totalPages">
        </el-pagination>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                //分页 -- sta
                pageInfo: {
                    page: 1,
                    size: 15,
                    packageId: this.$route.query.juanBuId,
                },
                totalPages: 0,
                //分页 -- end

                responseData: [
                    // 调试用假数据--正式版注释掉
                ],
            }
        },
        methods: {
            // 在打印当前报表前，拼接title
            initPrint(id) {
                this.utils.printTable(id, `入库单列表`)
            },

            // 分页切换
            handleCurrentChange(newNum) {
                this.getPeiBuList(newNum)
            },

            // 刷新
            refreshPage() {
                this.getList(1)
                this.$Message.success('刷新成功')
            },

            // 获取XX分页列表
            getList(val) {
                this.pageInfo.page = val
                this.$requestBase({
                    url: '/v1/factory/product-order/work-order/down-cloth/page/package',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.responseData = this.formatResponse(res.data.list)
                    this.totalPages = res.data.pages
                })
            },
            // 格式化XX列表
            formatResponse(response) {
                response.forEach((item, index) => {
                    //创建时间变换
                    item.createTime_change = this.$route.query.createTime_change

                    item.productLength = (item.productLength / 100).toFixed(2) //库存
                    //解决bug: 包裹明细中，过磅重量数值单位应从克 改 千克。
                    item.realWeight_change = (item.realWeight / 1000).toFixed(2) //过磅重量
                })
                return response
            },
            //给 所有 表格 自动 加行号
            indexMethod(index) {
                return index + 1;
            },
        },
        created() {},
        mounted() {
            // console.log('this.$route.query.juanBuId=', this.$route.query.juanBuId)
            // console.log('this.$route.query.juanbuNumber=', this.$route.query.juanbuNumber)
            // console.log('this.$route.query.createTime_change=', this.$route.query.createTime_change)
            
            // console.log('this.$route.query.warehouseName=', this.$route.query.warehouseName)
            // console.log('this.$route.query.positionName=', this.$route.query.positionName)

            this.getList(1)
        },
    }
</script>

<style scoped lang="scss">

</style>
